import { render } from "./Step4Component.vue?vue&type=template&id=7a504e0c&scoped=true"
import script from "./Step4Component.vue?vue&type=script&lang=js"
export * from "./Step4Component.vue?vue&type=script&lang=js"

import "./Step4Component.vue?vue&type=style&index=0&id=7a504e0c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a504e0c"]])

export default __exports__